<app-back-header-atom
  icon="arrow-left"
  [text]="'group-payments.title' | translate"
  [textColor]="textColor()"
  [backgroundColor]="backgroundColor()"
  (navigationClick)="back()"
></app-back-header-atom>
